"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLabelState = void 0;
const useToolsStateSelector_1 = require("./useToolsStateSelector");
const DEFAULT_STATE = [];
const useLabelState = () => (0, useToolsStateSelector_1.useToolsStateSelector)(state => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.labelsState) === null || _a === void 0 ? void 0 : _a.labels) !== null && _b !== void 0 ? _b : DEFAULT_STATE; });
exports.useLabelState = useLabelState;
